import { animate, state, style, transition, trigger } from '@angular/animations';
import {
  Component,
  ChangeDetectionStrategy,
  OnDestroy,
  ViewChild,
  ElementRef,
  Input,
  Output,
  EventEmitter,
  OnChanges,
} from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { Subject, takeUntil } from 'rxjs';
import { emailValidator } from '../../validators';

@Component({
  selector: 'osn-shared-email-input-with-button',
  templateUrl: './email-input-with-button.component.html',
  styleUrls: ['./email-input-with-button.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [
    trigger('errorAnimation', [
      state('valid', style({ marginTop: '-24px', opacity: 0 })),
      state('invalid', style({ marginTop: '0px', opacity: 1 })),
      transition('valid <=> invalid', animate('0.25s')),
    ]),
  ],
})
export class EmailInputWithButtonComponent implements OnDestroy, OnChanges {
  @Input() public inputPlaceholder: string;
  @Input() public buttonText: string;
  @Input() public isLoading: boolean;
  @Input() public theme = 'dark';
  @Input() public errors?: Record<string, string>;
  @Output() public buttonClick = new EventEmitter<string>();
  @Output() public loginError = new EventEmitter<void>();
  @ViewChild('emailInput') public emailInput: ElementRef;

  public emailFormControl = new FormControl('', [Validators.required, emailValidator()]);
  public showValidIcon = false;
  public emailError?: string;
  private readonly onDestroy$ = new Subject<void>();
  private readonly errorMap = {
    email: 'MLP_InvalidEmail_Label',
  };

  constructor() {
    this.emailFormControl.valueChanges.pipe(takeUntil(this.onDestroy$)).subscribe(() => {
      this.emailError = undefined;
      this.showValidIcon = false;
    });
  }

  public ngOnChanges(): void {
    if (this.errors) {
      this.emailFormControl.setErrors(this.errors);
      this.emailError = this.emailFormControl.getError('gw');
      this.loginError.emit();
    }
  }

  public getError(control: AbstractControl): void {
    if (this.emailFormControl.getError('gw')) {
      this.emailError = this.emailFormControl.getError('gw');
    }
    const errorKey = Object.keys(this.errorMap).find((key) => control.invalid && control.touched && control.hasError(key));
    this.emailError = errorKey ? this.errorMap[errorKey] : undefined;
  }

  public onBlur(): void {
    this.getError(this.emailFormControl);
    this.showValidIcon = true;

    if (this.emailFormControl.invalid) {
      this.emailInput.nativeElement.focus();
    }
    this.emailFormControl.markAsTouched();
  }

  public onButtonClick(): void {
    if (this.emailFormControl.valid) {
      this.buttonClick.emit(this.emailFormControl.value);
    }
  }

  public ngOnDestroy() {
    this.onDestroy$.next();
    this.onDestroy$.complete();
  }
}
